class RedirectToHomepageCtrl {
  constructor(private $window) {
    'ngInject';
  }

  $onInit() {
    this.$window.location.href = '/aptitude/static/platform/home/landing';
  }
}

export const RedirectToHomepageComponent = {
  controller: RedirectToHomepageCtrl,
  template: '',
};
